import React, { createContext, FC, ReactNode, useEffect, useState } from 'react'
import { Client } from '../../../types/localStorageModels'
import { rechercheProspect } from '../api/rechercheContactApi'

export interface RechercheContactContextProps {
	rechercheLoading: boolean
	resultatsContact: Client[]
	page: number
	setPage: (page: number) => void
	setResultatsContact: (resultats: Client[]) => void
	filtreContact: string,
	setFiltreContact: (filtre_texte: string) => void
	resetFiltreContact: () => void
}

export const RechercheContactContext = createContext<RechercheContactContextProps>({
	rechercheLoading: false,
	resultatsContact: [],
	page: 0,
	setPage: () => {
	},
	setResultatsContact: () => {
	},
	filtreContact: '',
	setFiltreContact: () => {
	},
	resetFiltreContact: () => {
	}
})

interface RechercheContactProviderProps {
	children: ReactNode
}

export const RechercheContactProvider: FC<RechercheContactProviderProps> = ({ children }) => {
	const [resultatsContact, setResultatsContact] = useState<Client[]>([])
	const [rechercheLoading, setRechercheLoading] = useState<boolean>(false)
	const [page, setPage] = useState<number>(0)
	const [filtreContact, setFiltreContact] = useState<string>('')

	useEffect(() => {
		// On fait la recherche quand le filtre texte a changé (on submit de la recherche)
		if (filtreContact.length) {
			setRechercheLoading(true)
			rechercheProspect(filtreContact)
				.then(setResultatsContact)
				.finally(() => {
					setRechercheLoading(false)
					// Réinitialise la page à 0
					setPage(0)
				})
		}
	}, [filtreContact])

	const resetFiltreContact = () => {
		setFiltreContact('')
		setResultatsContact([])
	}

	return (
		<RechercheContactContext.Provider
			value={{
				rechercheLoading,
				resultatsContact,
				page,
				setPage,
				setResultatsContact,
				filtreContact,
				setFiltreContact,
				resetFiltreContact
			}}
		>
			{children}
		</RechercheContactContext.Provider>
	)
}